export default __webpack_public_path__ + "static/media/app-logo.5b55c924.svg";